import { c as _c } from "react/compiler-runtime";
import clsx from "classnames";
import type { ContentSummaryVariantProps } from "common/components/ContentSummary/types";
import { BaseSummaryImage, BaseTitleBylineTag } from "common/components/ContentSummary/variants/Base";
export const DisappearingThumbnail = t0 => {
  "use memo";

  const $ = _c(20);
  let anchorTarget;
  let className;
  let image;
  let imageSizes;
  let props;
  let url;
  if ($[0] !== t0) {
    ({
      url,
      imageSizes,
      image,
      anchorTarget,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = anchorTarget;
    $[2] = className;
    $[3] = image;
    $[4] = imageSizes;
    $[5] = props;
    $[6] = url;
  } else {
    anchorTarget = $[1];
    className = $[2];
    image = $[3];
    imageSizes = $[4];
    props = $[5];
    url = $[6];
  }
  let t1;
  if ($[7] !== className) {
    t1 = clsx("group grid w-full grid-cols-3 gap-x-4 outline-offset-4 2xl:grid-cols-5 2xl:gap-x-8", className);
    $[7] = className;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== props) {
    t2 = <BaseTitleBylineTag {...props} />;
    $[9] = props;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== image || $[12] !== imageSizes) {
    t3 = <BaseSummaryImage image={image} imageSizes={imageSizes} wideClassName="sm:hidden 2xl:block 2xl:col-span-2" />;
    $[11] = image;
    $[12] = imageSizes;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== anchorTarget || $[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== url) {
    t4 = <article className="contents"><a href={url} target={anchorTarget} className={t1}>{t2}{t3}</a></article>;
    $[14] = anchorTarget;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = url;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};